const formatItemLabel = (item) => {
    switch (item.label) {
        case '10':
            item.label = 'Presentations';
            break;
        case 'back-office-operations':
            item.label = 'Back Office/Operations';
            break;
        case 'front-middle-office':
            item.label = 'Front/Middle Office';
            break;
        case 'it-technology':
            item.label = 'IT/Technology';
            break;
        default:
            const words = item.label.split('-');
            words.map((word, index) => {
                words[index] = word[0].toUpperCase() + word.substring(1);
            }, words);

            item.label = words.join(' ');
    }

    return item;
};

const sortItems = (items) => {
    items.sort((a, b) => {
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();

        if (labelA < labelB) {
            return -1;
        }
        if (labelA > labelB) {
            return 1;
        }

        return 0;
    });

    return items;
};

export { formatItemLabel, sortItems };
